const defaultDisableFor = '[data-disable-interfere-submit]';

const disableSubmit = (elm) => {
  const icon = document.createElement('i');
  icon.classList.add('icon-spinner-outline', 'rotate');
  elm.classList.add('has-icon');
  elm.appendChild(icon);
  elm.disabled = true;
};

export function initFormSubmitInterfere(config = {}, targetEl) {
  const target = targetEl || document;
  const { enableFor, disableFor } = config;
  const selector = `form${enableFor || ''}:not(${disableFor || defaultDisableFor})`;
  const forms = [...target.querySelectorAll(selector)];
  forms.forEach((form) => {
    let submitted = false;
    const submits = form.querySelectorAll('[type="submit"]');
    form.addEventListener('submit', (e) => {
      if (submitted) {
        e.preventDefault();
      }
      submits.forEach(disableSubmit);
      submitted = true;
    });
  });
}
